export const getCurrentDialog = ({ dialog }) => dialog.currentDialog;
export const getDialogProps = ({ dialog }) => dialog.dialogProps;
